module.exports = __webpack_public_path__ + "static/android-jquery-react-84ee9dc999624a4bb17d5780bb2cd77b.png";